import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { OAuth2Client, CodeVerificationStrategy } from '@kolorado/oauth';
import Authentication from '../authentication';
import { checkEnvironment } from '../../utilities';
import { processEnvironmentVariables, EnvironmentVariableType } from '../../process-environment';
import { loginActionNames } from '../../store/login/types';
import { safeParseJwtPayload } from '../authentication/jwt';

const fedLoginURL = process.env.REACT_APP_FEDLOGIN_URL || '';
const appURL = window.location.origin;

const environment: EnvironmentVariableType = processEnvironmentVariables(checkEnvironment());

const authClient = OAuth2Client.of({
  uri: fedLoginURL + environment.authRedirect,
  tokenURI: fedLoginURL + environment.tokenURI,
  clientID: environment.clientId,
  redirectURI: appURL + environment.redirectURI,
  antiForgeryTtl: environment.antiForgeryTtl,
  proofCodeTtl: environment.proofCodeTtl,
  leniency: environment.leniency,
  oauthAdapter: 'OAuthAdapterCCDS',
  responseType: 'code',
  codeVerification: CodeVerificationStrategy.SYNCHRONIZED,
});

const getLoginIdFromAccessToken = (accessToken?: string | null): string => {
  if (!accessToken) {
    return '';
  }

  const payload = safeParseJwtPayload(accessToken);
  const candidates = [
    payload?.loginId,
    payload?.login_id,
    payload?.preferred_username,
    payload?.user_name,
    payload?.username,
    payload?.uid,
    payload?.sub,
  ];
  const first = candidates.find((v) => typeof v === 'string' && v.length > 0);
  return typeof first === 'string' ? first : '';
};
const originalAuthenticate = (authClient as any).authenticate.bind(authClient);
(authClient as any).authenticate = (options?: any) => {
  if (options && Object.keys(options).length > 0) {
    return originalAuthenticate(options);
  }

  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  const loginId = getLoginIdFromAccessToken(accessToken);

  if (accessToken || refreshToken) {
    return {
      loginId,
      metadata: {
        catloginid: loginId,
      },
    };
  }
  return originalAuthenticate({ clientToken: 'CustomerMasterUI_ac_client' });
};

type AuthLayerProperties = {
  children: any;
};
const AuthLayer = (properties: AuthLayerProperties) => {
  const { children } = properties;
  const dispatch = useDispatch();

  useEffect(() => {
    if (environment) {
      dispatch({
        type: loginActionNames.SET_ENV_VARIABLES,
        payload: environment,
      });
    }
  }, [dispatch]);

  useEffect(() => {
    Authentication(window.location.search, authClient, dispatch);
  }, [dispatch]);
  return children;
};
export default AuthLayer;
